// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyA-lRkZOi0l-8pEOfZ31RbIZfJo3CWKGRA",
  authDomain: "rate-the-ranch-app.firebaseapp.com",
  databaseURL: "https://rate-the-ranch-app-default-rtdb.firebaseio.com",
  projectId: "rate-the-ranch-app",
  storageBucket: "rate-the-ranch-app.firebasestorage.app",
  messagingSenderId: "586541421271",
  appId: "1:586541421271:web:95eb2f77e6db1e4bf4d692",
  measurementId: "G-7MZH34Z9DG"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// --- App Check ---
// Attests that requests come from this genuine app (via reCAPTCHA v3),
// blocking scripted/automated abuse of the public write rules. It stays
// inert until REACT_APP_RECAPTCHA_SITE_KEY is set, so the app keeps working
// before App Check is configured in the Firebase console.
const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (appCheckSiteKey) {
  // In development, allow a debug token so localhost works without a live
  // reCAPTCHA challenge. The token is printed to the console on first run —
  // register it under App Check → Manage debug tokens.
  if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  console.warn(
    'App Check disabled: set REACT_APP_RECAPTCHA_SITE_KEY to enable it.'
  );
}

// Initialize Firestore
const db = getFirestore(app);

// Initialize Auth (used for anonymous sign-in so ratings can be
// limited to one vote per person per restaurant/condiment).
export const auth = getAuth(app);

// ✅ Fix: Use default export or named export
export default db;
